import { Box, Button, FormControl, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { memo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useTheme } from '@emotion/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createDealerPayment, getAllDealersData, getDealerPayment, updateDealerPayment } from '../../../redux/slice/dealerPayment.slice';

const Dealerpaymentshow = () => {
    const DealerRegister = useSelector(state => state.dealer.Dealer);
    const DealerRegister1 = useSelector(state => state.dealerPayment.dealersData)
    const dispatch = useDispatch()
    const location = useLocation();
    const dealerData = location.state.dealer;
    const isMobile = useMediaQuery('(max-width:500px)');
    const date = location.state.date;
    const dealerUser = DealerRegister1?.find(user => user.dealerUserData[0]?._id === dealerData?.name)?.dealerUserData[0];
    const AllDealerpayment = useSelector(state => state.dealerPayment.DealerPayment)
    const [dealerpayment, setdealerpayment] = React.useState()
    const [singledealer, setSingledealer] = useState()
    useEffect(() => {
        setSingledealer(DealerRegister?.find(v => v._id == userId))
    }, [])

    const navigate = useNavigate()
    const { state } = useLocation();

    console.log("state", state);


    const id = state?.id;
    const dealermonth = state?.date;
    const userId = state?.userId;
    const theme = useTheme();

    const validationSchemas =
        Yup.object({});

    const initialValues = {
        DealerPaymentInvoiceNo: '',
        userId: userId,
        dealermonth: dealermonth,
        DealerPaymentDetails: [{
            fileNo: '',
            consumerName: '',
            systemSize: '',
            commissionPerKW: '',
            totalCommission: '',
            DealerPaymentDate: '',
            DealerPaymentAmount: '',
            DealerPaymentTDS: '',
            DealerPaymentTotal: '',
        }]
    };

    const [DealerpaymentData, setDealerpaymentData] = React.useState(initialValues.DealerPaymentDetails)
    useEffect(() => {
        dispatch(getDealerPayment())
        dispatch(getAllDealersData())
    }, [dispatch])

    const [selectedDealers, setSelectedDealers] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(null);

    useEffect(() => {
        const dataToSubmit = DealerRegister1?.filter(v => v.isDisabled);
        setSelectedDealers(dataToSubmit);
    }, [DealerRegister1])

    useEffect(() => {
        if (dealerData) {
            const commissionDate = new Date(dealerData.commisionCreatedAt);
            const monthYear = commissionDate.toLocaleString('default', { month: 'long', year: 'numeric' });
            setSelectedMonth(monthYear);
        }
    }, [dealerData]);

    useEffect(() => {
        if (AllDealerpayment) {
            setdealerpayment(AllDealerpayment?.find(v => v._id == id && v.dealermonth == dealermonth))
        }
    }, [id, AllDealerpayment])

    const [isEditMode, setIsEditMode] = useState(!!state?.dealer);
    const [existingData, setExistingData] = useState(state?.dealer || []);


    const formatDateForInput = (dateStr) => {
        console.log("isEditMode && existingData.length", dateStr);

        if (!dateStr || dateStr === '') return '';
        const [dd, mm, yyyy] = dateStr.split('/');
        return `${yyyy}-${mm}-${dd}`;
    };

    useEffect(() => {
        console.log("isEditMode && existingData.length", isEditMode && existingData.length, existingData);

        if (isEditMode && existingData.length) {
            const updated = existingData.map(item => ({
                _id: item._id,
                fileNo: item.fileNo,
                consumerName: item.consumerName,
                systemSize: item.systemSize,
                commissionPerKW: item.commissionPerKW,
                totalCommission: item.totalCommission,
                DealerPaymentDate: item.DealerPaymentDate !== '' ? formatDateForInput(new Date(item.DealerPaymentDate)?.toLocaleDateString()) || '' : '',
                DealerPaymentAmount: item.DealerPaymentAmount || '',
                DealerPaymentTDS: item.DealerPaymentTDS || '',
                DealerPaymentTotal: (
                    Number(item.DealerPaymentAmount || 0) + Number(item.DealerPaymentTDS || 0)
                ).toFixed(2),
            }));

            console.log("updated", updated);

            setValues(prev => ({
                ...prev,
                DealerPaymentDetails: updated,
            }));
        }
    }, [isEditMode, existingData]);


    const handleSubmit = () => {
        const details = values.DealerPaymentDetails || [];

        console.log("details", details);


        // keep all rows that have at least fileNo (or any identifying data)
        const validDetails = details.filter(
            entry => entry?.fileNo || entry?.consumerName || entry?.DealerPaymentDate
        );

        if (validDetails.length === 0) {
            alert("No dealer payment data to submit.");
            return;
        }

        const validEntry = {
            _id: state?.deaperPayementId || '',
            DealerPaymentInvoiceNo: state?.v?.invoiceNo,
            userId: state?.userId,
            dealermonth: '',  // <-- add month
            DealerPaymentDetails: validDetails,  // keep all (changed + unchanged)
            status: ''
        };

        console.log("values to submit", validEntry);

        dispatch(createDealerPayment(validEntry));

        resetForm();

        navigate('/admin/dealer-payment');


    };


    // const handleSubmit = () => {
    //     const details = values.DealerPaymentDetails || [];

    //     // keep only fully filled rows
    //     const validDetails = details.filter(
    //         entry => entry?.DealerPaymentDate && entry?.DealerPaymentAmount && entry?.DealerPaymentTDS
    //     );

    //     if (validDetails.length === 0) {
    //         alert("Please fill Date, Payment, and TDS in at least one row before submitting.");
    //         return;
    //     }

    //     // build single payload
    //     const validEntry = {
    //         _id: state?.deaperPayementId || '',
    //         DealerPaymentInvoiceNo: state?.v?.invoiceNo,
    //         userId: state?.userId,
    //         dealermonth: '',
    //         DealerPaymentDetails: validDetails,   // only valid ones
    //         status: ''
    //     };

    //     console.log("values 1", validEntry);


    // };

    useEffect(() => {
        if (id && dealerpayment) {
            setValues(dealerpayment);
            setDealerpaymentData(dealerpayment.DealerPaymentDetails)
        }
    }, [id, dispatch, dealerpayment]);

    const handleAddDealerpayment = () => {
        const newPayment = {
            DealerPaymentDate: '',
            DealerPaymentAmount: '',
            DealerPaymentTDS: '',
            DealerPaymentTotal: '',
        };

        setDealerpaymentData(prevData => {
            const updatedData = [...prevData, newPayment];
            return updatedData;
        });

        setFieldValue('DealerPaymentDetails', [...values.DealerPaymentDetails, newPayment]);
    };

    const { handleBlur, handleChange, values, touched, errors, resetForm, setFieldValue, setValues, validateForm } = useFormik({
        initialValues: { ...initialValues, DealerPaymentDetails: DealerpaymentData },
        validationSchema: validationSchemas,
    });





    const renderFabRows = (dealers) => {


        const totalLength = Math.max(dealers?.length);
        while (dealers?.length < totalLength) {
            dealers?.push({});
        }
        const rows = [];
        for (let i = 0; i < totalLength; i++) {
            console.log("dealerssss", dealers);

            const dealer = dealers[i] || {};
            // const foundItem = dealer.marketData?.[0] || {};

            const foundItem = '';
            const fillNo = dealers?.fileNo || 'N/A';

            rows.push(
                <TableRow key={`dealer-${i}`}>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer?.fileNo || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px', textWrap: 'nowrap' }}>{dealer?.consumerName || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.systemSize || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.commissionPerKW || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer?.fileNo ?  dealer.totalCommission : '-'}</TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.DealerPaymentDetails?.[i]?.DealerPaymentDate || ''}
                                name={`DealerPaymentDetails[${i}].DealerPaymentDate`}
                                error={
                                    !!touched.DealerPaymentDetails?.[i]?.DealerPaymentDate &&
                                    !!errors.DealerPaymentDetails?.[i]?.DealerPaymentDate
                                }
                                helperText={
                                    touched.DealerPaymentDetails?.[i]?.DealerPaymentDate &&
                                    errors.DealerPaymentDetails?.[i]?.DealerPaymentDate
                                }
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.DealerPaymentDetails?.[i]?.DealerPaymentAmount || ''}
                                name={`DealerPaymentDetails[${i}].DealerPaymentAmount`}
                                error={
                                    !!touched.DealerPaymentDetails?.[i]?.DealerPaymentAmount &&
                                    !!errors.DealerPaymentDetails?.[i]?.DealerPaymentAmount
                                }
                                helperText={
                                    touched.DealerPaymentDetails?.[i]?.DealerPaymentAmount &&
                                    errors.DealerPaymentDetails?.[i]?.DealerPaymentAmount
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment TDS :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.DealerPaymentDetails?.[i]?.DealerPaymentTDS || ''}
                                name={`DealerPaymentDetails[${i}].DealerPaymentTDS`}
                                error={
                                    !!touched.DealerPaymentDetails?.[i]?.DealerPaymentTDS &&
                                    !!errors.DealerPaymentDetails?.[i]?.DealerPaymentTDS
                                }
                                helperText={
                                    touched.DealerPaymentDetails?.[i]?.DealerPaymentTDS &&
                                    errors.DealerPaymentDetails?.[i]?.DealerPaymentTDS
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Total :"
                                onBlur={handleBlur}
                                value={
                                    Number(values.DealerPaymentDetails?.[i]?.DealerPaymentAmount || 0) +
                                    Number(values.DealerPaymentDetails?.[i]?.DealerPaymentTDS || 0)
                                }
                                name={`DealerPaymentDetails[${i}].DealerPaymentTotal`}
                                error={
                                    !!touched.DealerPaymentDetails?.[i]?.DealerPaymentTotal &&
                                    !!errors.DealerPaymentDetails?.[i]?.DealerPaymentTotal
                                }
                                helperText={
                                    touched.DealerPaymentDetails?.[i]?.DealerPaymentTotal &&
                                    errors.DealerPaymentDetails?.[i]?.DealerPaymentTotal
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    {/* <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentDate || ''}
                                name={`fileDetails[${i}].PaymentDate`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentDate &&
                                    !!errors.fileDetails?.[i]?.PaymentDate
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentDate &&
                                    errors.fileDetails?.[i]?.PaymentDate
                                }
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentAmount || ''}
                                name={`fileDetails[${i}].PaymentAmount`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentAmount &&
                                    !!errors.fileDetails?.[i]?.PaymentAmount
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentAmount &&
                                    errors.fileDetails?.[i]?.PaymentAmount
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment TDS :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentTDS || ''}
                                name={`fileDetails[${i}].PaymentTDS`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTDS &&
                                    !!errors.fileDetails?.[i]?.PaymentTDS
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTDS &&
                                    errors.fileDetails?.[i]?.PaymentTDS
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Total :"
                                onBlur={handleBlur}
                                value={
                                    Number(values.fileDetails?.[i]?.PaymentAmount || 0) +
                                    Number(values.fileDetails?.[i]?.PaymentTDS || 0)
                                }
                                name={`fileDetails[${i}].PaymentTotal`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTotal &&
                                    !!errors.fileDetails?.[i]?.PaymentTotal
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTotal &&
                                    errors.fileDetails?.[i]?.PaymentTotal
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell> */}
                </TableRow>
            );
        }
        return rows;
    };

    console.log("updated", values);
    return (
        <SnackbarProvider maxSnack={3}>
            <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
                <Header
                    title="DEALER COMMISSION"
                    subtitle="Manage Your Dealer Commission Here"
                />
                {state?.dealer?.length > 0 && (
                    <Box sx={{
                        m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                        bgcolor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0',
                    }}>
                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                            Invoice No: {state?.v?.invoiceNo} &nbsp;&nbsp;&nbsp;&nbsp;
                            Type: Dealer &nbsp;&nbsp;&nbsp;&nbsp;
                            Total Amount: {state?.v?.amount % 1 === 0 ? state?.v?.amount.toString() : state?.v?.amount.toFixed(2)}
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            {
                                state?.dealer?.map((v, index) => {
                                    return (
                                        <div key={v._id}>
                                            {v.fileNo
                                                ? "File No: " + v.fileNo + " - " + (Number(v.totalCommission))
                                                : "Extra Amount: " + (Number(v.DealerPaymentAmount) + Number(v.DealerPaymentTDS))}
                                        </div>
                                    );
                                })
                            }

                        </Typography>
                        <TableContainer>
                            <Table style={{ width: '100%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>File No.</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Name</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>System Size</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Commision Per KW</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Dealer Commission</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Date</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Payment</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>TDS</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Account Payable</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {renderFabRows(values.DealerPaymentDetails)}
                                    <TableRow>
                                        <TableCell colSpan={9} sx={{ borderBottom: 'none' }}>
                                            <Box display="flex" justifyContent="flex-end" m={1}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<AddIcon />}
                                                    onClick={handleAddDealerpayment}
                                                >
                                                    Add Dealer Payment
                                                </Button>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {
                            state?.dealer?.map((v, index) => {
                                console.log("v, index", v, index);
                                <Box key={index} sx={{
                                    m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                                    bgcolor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0',
                                }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-evenly', overflowX: 'auto', whiteSpace: 'nowrap', px: 2 }}>

                                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                                            {/* Invoice No: {`Dealer/${dealerUser?.name || 'Unknown'}/${new Date(endDate).getDate()}/${new Date(endDate).getMonth() + 1}/${new Date(endDate).getFullYear()}`} */}
                                        </Typography>
                                        <Typography variant="h6" sx={{ mb: 2, }}>
                                            {/* {dealers.length > 0 ? dealers.map(dealer => {
                                        const foundItem = dealer.data?.[0];
                                        return (
                                            <div key={dealer._id}>
                                                File No: {foundItem?.fillNo} - {foundItem?.TotalCommission}
                                            </div>
                                        );
                                    }) : 'N/A'} */}
                                        </Typography>
                                    </Box>
                                    <TableContainer>
                                        <Table style={{ width: '100%' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>File No.</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Name</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>System Size</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Commision Per KW</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Dealer Commission</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Date</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Payment</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>TDS</TableCell>
                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Account Payable</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* {renderDealerRows(dealers, DealerpaymentData)} */}
                                                {renderFabRows(v)}
                                                <TableRow>
                                                    <TableCell colSpan={9} sx={{ borderBottom: 'none' }}>
                                                        <Box display="flex" justifyContent="flex-end" m={1}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<AddIcon />}
                                                                onClick={handleAddDealerpayment}
                                                            >
                                                                Add Dealer Payment
                                                            </Button>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            })
                        }

                        <Box display="flex" mt={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    boxShadow: 5,
                                    '&:hover': {
                                        boxShadow: 6,
                                    }
                                }}
                                onClick={handleSubmit}
                            >
                                Accept Request
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        </SnackbarProvider>

    )
}

export default memo(Dealerpaymentshow);